export const ALLOWED_EMAILS = [
  "trader@themarketsniper.com",
  "bernard@themarketsniper.com",
  "litvinxenia@gmail.com",
  "hello@inflow.surf",
  "aalvino@protonmail.com",
  "greggibba@yahoo.co.uk",
  "hawalafahmi@gmail.com",
  "lourens.dewald@gmail.com",
  "j.wall@tuta.io",
  "alexejlitvin@yahoo.de",
  "cnjackson@fastmail.com",
  "wesmckenna@gmail.com",
  "test@test.com",
  "steerwiththerear58@icloud.com",
  "kungfufalkor@gmail.com",
  "Ojonorr888@gmail.com",
  "kken.ma@gmail.com",
  "michaelowenmcd@gmail.com",
  "GLAD1988@proton.me",
  "wesmckenna@gmail.com",
]
